import { render, staticRenderFns } from "./ProductsGrid.vue?vue&type=template&id=c82b38e8&"
import script from "./ProductsGrid.vue?vue&type=script&lang=js&"
export * from "./ProductsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports